<template>
  <div class="page-header page-home">
    <div class="text">
      <!-- <div class="title">{{ agreementData.name }}</div>
      <div v-html="agreementData.content"></div> -->
      <img class="imgDeal" v-if="type == 1" src="../../assets/ChongQinGMobileImg/deal1.jpg" alt="">
      <img class="imgDeal" v-else-if="type == 2" src="../../assets/ChongQinGMobileImg/deal2.png" alt="">
      <div v-else-if="type == 3">
        <h3>中国移动通信客户服务协议</h3>
<p>甲方：       （客户）   </p> 
<p>乙方：中国移动通信集团重庆有限公司</p>
<p>前言：请您审慎阅读、理解协议内容，对可能涉及限制、免责条款或者其他重大权益的条款乙方可能以加粗、加下划线等形式提示您重点注意。</p>
<p>一、服务内容及服务承诺</p>
<p>1.甲方愿意使用乙方提供的号码，或者使用甲方自其它运营商携号转网携入的号码,接受乙方提供的电信服务及互联网基础功能类服务（如无特别说明，以下所称电信服务均为乙方提供的前两类服务的统称），乙方愿意在现有技术条件下网络覆盖范围内以及签订有漫游协议的电信运营商的网络覆盖范围内为甲方提供电信服务，具体服务内容由甲乙双方通过签署业务受理单或其他方式另行约定。</p>
<p>2.甲方可以自主选择是否订购第三方服务商提供的由乙方代收服务费的增值电信业务（以下简称“代收费业务”）。</p>
<p>3.乙方提供的电信服务应当符合法律法规的规定及政府主管部门发布的相关标准；甲方使用乙方提供的服务应遵守法律法规规定。</p>
<p>4.乙方将通过营业厅、门户网站、10086热线等渠道公示服务项目、服务时限、服务范围及资费标准等内容。乙方定期将最新优惠活动、最新产品及时通过10086官方短信端口、10086/10085热线、手机营业厅等方式告知甲方知晓。</p>
<p>5.乙方向甲方提供便捷的业务办理和客户投诉受理渠道，乙方应在接客户投诉之日起4８小时内回复。</p>
<p>二、入网登记</p>
<p>1.甲方使用乙方号码或自其他运营商携号转网携入的号码，并接受乙方提供的电信服务，需办理入网登记手续。甲方办理入网登记手续时，应当按照《电话用户真实身份信息登记规定》（工业和信息化部令第25号）向乙方出示有效证件，提供真实身份信息。
甲方委托他人办理入网手续的，受托人应当出示甲方和受托人的有效证件，并提供甲方和受托人的真实身份信息。
甲方应具有完全的民事行为能力。甲方为无民事行为能力人或限制民事行为能力人的，应由其监护人代理甲方签署本协议。</p>
<p>2.甲方或其受托人拒绝出示有效证件，拒绝依照本协议提供身份信息，冒用他人的证件，或者使用伪造、变造的证件的，拒绝现场拍摄和留存照片的，乙方有权不为其办理入网手续；已经办理入网手续的，乙方在查证前述情况后有权暂停或终止为甲方提供本合同项下的电信服务。</p>
<p>3.甲方名下在全国范围内已经达到5个中国移动号码的，将无法再办理新的中国移动号码入网。如甲方入网登记资料发生变更，应及时到乙方营业厅或乙方指定的其他渠道办理资料完善手续。因甲方或其受托人提供的资料不详、不实或变更后未及时办理资料完善手续等原因所造成的后果由甲方自行承担。</p>
<p>4.甲方从转让方受让本协议项下号码使用权的，应与转让方协商一致，甲方和转让方应向乙方出示双方有效身份证件原件。甲方或转让方中任何一方拒绝出示有效证件，拒绝提供其证件上所记载的身份信息，冒用他人的证件，或者使用伪造、变造的证件的，乙方有权拒绝办理过户登记手续，并不为甲方办理入网手续。若甲方冒用他人的证件，或者使用伪造、变造的证件成功办理过户登记手续的，给转让方造成损失的，所有责任由甲方承担。若司法机关及相关部门认定乙方承担赔偿责任的，乙方有权向甲方追偿。
过户后，甲方取得该号码使用权，并承继该号码账户中的余额、积分及转让方与乙方签署的《中国移动通信客户服务协议》项下的所有义务（本协议另有约定的除外），并遵守本协议。甲方同意承担转让方在过户前可能发生而未出账的费用；过户后，甲方和转让方就本协议项下号码的权利义务发生争议的，由双方自行协商解决；过户后，甲方不得向乙方提出过户前转让方通话清单、账单查询打印的要求；过户后，甲方应尽快修改或设置密码，如因密码未设置、修改或保管不善造成的后果由甲方自行承担。
甲方和转让方须保证其为本协议号码的真实使用权人，没有任何第三方对该号码的使用权提出权利主张，其提供的身份证件和资料均真实有效。甲方和转让方前述保证虚假不实的，乙方有权无条件解除本协议及转让方与乙方的协议，号码由乙方收回。</p>
<p>5.如甲方入网登记资料发生变更，应及时到乙方营业厅办理资料完善手续。因甲方提供的资料不详、不实或变更后未及时办理资料完善手续等原因造成的后果由甲方自行承担。</p>
<p>6.甲方入网后自动获取客户初始服务密码的，应立即修改初始服务密码并妥善保管。因密码保管不善造成的后果由甲方自行承担，乙方有义务按照法律规定协助有关国家机关依据职权等调查相关情况。为方便办理业务，乙方可根据甲方申请以短信等方式提供随机密码，该密码可作为办理业务的临时凭证。凡使用服务密码或随机密码办理业务的行为均被视为甲方或甲方授权的行为。</p>
<p>7.甲方因SIM卡丢失或损坏等原因需办理补卡手续或换卡手续时，甲方可凭在乙方登记的有效身份证件原件及相关证明材料到乙方营业网点办理，或通过乙方指定的其他方式办理。甲方委托他人代办需同时提供甲方及受托人真实有效身份证件原件及委托书。乙方可以收取相应费用。</p>
<p>三、资费及费用交纳</p>
<p>1.甲方使用乙方提供的电信服务应支付相关费用，乙方收取的相关费用应符合法律法规的规定和甲乙双方的约定。</p>
<p>2.甲方有权要求乙方提供免费的话费查询服务，乙方有义务对账单、详单进行解释。</p>
<p>3.甲方应按照与乙方约定的时间、方式，向乙方交纳费用账单中记载的全部费用，单笔交费或充值的最低限额为20元。甲方超过约定交费日未交足费用（以下称“欠费”），乙方有权暂停提供服务(以下称“欠费停机”)，并可以按照所欠费用自应交费日次日起每日加收3‰（千分之三）的违约金。欠费停机期间,互联网基础功能类服务仍可通过互联ID及密码正常使用，但需要用手机话费支付的收费功能暂停，甲方可选择改用其他支付方式，直至号码恢复正常。自欠费停机之日起60日内，如甲方交清欠费和违约金的，乙方应在甲方交清欠费和违约金后的48小时内恢复暂停的服务（以下简称“复机”）。欠费停机满60日，甲方仍未足额交清欠费和违约金的，乙方有权终止提供电信服务（以下简称“销号”）和解除协议,并可以通过信函、公告、委托第三方等方式追缴全部欠费和违约金。</p>
<p>4.甲方在欠费停机期间，停机当月和复机当月（指日历月）的月使用费（套餐费）照常计收。除双方另有约定外，欠费停机跨整月不收取月使用费（套餐费）。</p>
<p>5.甲方可以自行申请办理停机保号业务，停机保号期间收取停机保号费。
若甲方未及时足额缴纳停机保号费而导致欠费60天以上（含）的，乙方有权注销该号码，并有权对该号码资源进行回收再分配。</p>
<p>6.甲方名下的移动电话号码逾期未交清费用的,乙方有权拒绝甲方名下所有移动电话号码的业务办理，但交费、话费查询除外。</p>
<p>7.乙方对计费原始数据保留期限为6个月(系统产生用户话单当月起后6个月，不含当月)。若甲方对乙方收取的费用存有异议，应在异议费用发生后6个月内向乙方提出(系统产生用户话单当月起后6个月，不含当月)。乙方对甲方在异议话费发生后6个月内提出异议的话单，应保存至异议解决为止。</p>
<p>8.甲方对乙方收取的费用提出异议的，乙方有责任进行调查、解释，经核实确属乙方责任多收费用的，乙方应将已多收的部分双倍返还甲方。</p>
<p>9.甲方发生异常巨额电信费用时，乙方应当尽可能提示甲方；无法通知甲方或在合理时间内得不到甲方反馈信息的，乙方有权根据实际情况决定是否停机。无论乙方是否作停机处理，均不对甲方承担任何责任。    </p>
<p>10.如果甲方订购第三方服务商的代收费业务，则视同甲方同意乙方代第三方服务商向甲方收取服务费。该服务费的资费标准由第三方服务商制订并告知甲方。若甲方对收取的代收费业务服务费有异议，可在乙方协助下与第三方服务商协商解决。</p>
<p>11.甲方应妥善保管自己的号码不被非法盗用，若发现通信费用异常增长，可及时拨打客服热线10086或到乙方营业网点或乙方指定的其他渠道办理停机手续，并向公安机关报案；乙方应积极配合甲方和公安部门调查相关情况，但乙方不承担甲方因前述行为所造成的不良后果，甲方负有相应的交费义务。</p>
<p>四、协议的变更、终止与转让</p>
<p>1.乙方承诺资费方案有效期为一年（双方特殊约定的除外）。乙方有权在有效期截止后修改资费方案。如需修改，乙方应在修改前两个月通知甲方，甲方可以选择修改后的资费方案或乙方提供的其他资费方案。如无需修改，则原资费方案顺延一年，顺延次数不限。</p>
<p>2.除双方另有约定外，甲方可以选择变更资费方案。</p>
<p>3.经甲乙双方协商一致，甲方可以将本协议项下的号码过户给第三人。甲方和第三人保证其为本协议号码的真实使用权人，没有任何第三方对该号码的使用权提出权利主张，应持双方真实有效身份证件原件，按照《电话用户真实身份信息登记规定》（工业和信息化部令第25号）到乙方营业网点办理过户手续，如上述保证虚假不实的，乙方有权解除本协议，并回收相关号码。在甲方结清所有费用后由第三人与乙方重新签订客户入网协议，本协议自动终止；在办理变更手续之前，因使用该号码导致的交费义务及一切后果仍由甲方承担，第三人同意负责甲方在过户前可能发生而未出账的费用的除外。过户后，第三人取得该号码使用权，并承继该号码帐户中的余额、积分及转让方与乙方签署的《中国移动通信客户服务协议》项下的所有义务（本协议另有约定的除外），并遵守本协议。</p>
<p>4.甲方可以持登记的有效身份证件到乙方营业网点要求终止提供服务（以下简称销户）。销户后，甲方可凭借互联账户及密码继续使用移动互联基础功能类服务（不能使用付费的互联网增值服务）。除双方另有约定外，乙方不应拒绝甲方销户，甲方应在销户前结清所有费用。一旦出现销户前发生的、但销户时尚未能结算而产生的相关费用，待出账后乙方有权向甲方收取。甲方如不交纳费用，乙方有权向甲方追缴。销户手续办理完毕后，甲方与乙方签订的《中国移动通信客户服务协议》及相关服务协议自行终止，销户90天后，乙方可以重新启用甲方原号码。</p>
<p>5.甲方将本协议项下号码留作银行及其它服务行业的联系电话，或用作第三方业务的认证捆绑电话时，应在申请办理本协议项下号码的销户前主动变更所留存的联系电话号码或解除捆绑关系。本协议项下号码因甲方欠费停机或因欠费导致被乙方注销，或甲方申请注销前未主动变更或解除绑定关系的，号码被注销后导致的甲方无法收到相应通知信息、信息泄露或无法使用所捆绑的第三方业务的不利后果，由甲方自行承担。如该号码被乙方重新启用并分配给新客户使用的，因新客户收到相应信息而造成甲方信息泄露或财产损失的，乙方不承担责任。</p>
<p>6.甲方在未参与赠送、销售优惠等营销活动的情况下，销户时，可以预约将余额一次性转入另一乙方有效号码的账户；甲方在参与赠送、销售优惠等营销活动情况下，费用余额按营销活动协议约定进行处理。</p>
<p>7. 过户后，甲方和受让方就本协议项下号码的权利义务发生争议的，由双方自行协商解决。 </p>
<p>8. 如遇政府主管部门对资费等相关内容的政策发生变化，乙方将根据相关要求，对原资费方案进行相应调整。调整后方案的具体执行时间以乙方公示为准。</p>
<p>9.有下列情况之一的，乙方有权解除本协议，收回号码，并追缴欠费，终止提供服务，由此造成的后果由甲方自行承担：</p>
<p>（1）甲方（包括代理人）提供的证件或资料虚假不实； </p>
<p>（2）利用乙方提供的服务从事违法犯罪活动；</p>
<p>（3）利用乙方提供的服务从事违背公序良俗的活动；</p>
<p>（4）发送违法信息、未经接收客户同意大量发送骚扰信息或拨打骚扰、诈骗电话等不当行为；</p>
<p>（5）甲方将已登记本人身份证信息的号码卡随意丢弃或转卖，被诈骗等违法犯罪人员利用的；</p>
<p>（6）乙方收到国家有关部门通知要求停止向甲方提供通信服务；</p>
<p>（7）甲方欠费满60日仍未交纳费用；</p>
<p>（8）甲方突然出现超过自己此前三个月平均通信费用5倍的通信费用的；</p>
<p>（9）本合同约定的其他情形。</p>
<p>10.如果甲方丧失民事主体资格,本协议自动终止。乙方有权作销户处理，收回号码，终止提供电信服务。</p>
<p>五、携号转网</p>
<p>1.甲方申请携号转网服务的相关权利义务说明如下：</p>
<p>（1）甲方有权依据国家携号转网相关的有效规定，向乙方申请携号转网。</p>
<p>（2）乙方根据甲方申请，为甲方办理携号转网过程中，乙方需要将必要的甲方资料提供给携号转网集中业务管理系统，以用于比对携入方和携出方登记的号码使用人身份信息是否一致。</p>
<p>（3）甲方办理携号转网（包括转入、转出）应符合相关条件并提供所需要的材料。甲方携号转网的条件及所需要的材料，乙方已通过营业网点、门户网站、10086热线等渠道进行公示。</p>
<p>2.甲方向乙方申请将号码携出至其他运营商网络的，在完成网络切换后，乙方终止向甲方提供电信服务。甲方应在完成网络切换后30日内或在收到账单后10日内向乙方结清携出时未出账的费用。甲方超过约定交费日未交足费用的，乙方有权按照所欠费用自交费日次日起每日加收3‰（千分之三）的违约金，且乙方有权将甲方欠费信息共享给甲方的携入方运营商，并委托携入方运营商向甲方代为追缴甲方所欠费用及违约金。</p>
<p>3.甲方携带其他运营商号码与乙方签订本协议的，乙方有权根据携出方运营商的委托，代其追缴甲方在号码携出时未结清的携出方运营商的电信费用及违约金，追缴方式包括但不限于从甲方话费账户中扣减。</p>
<p>六、隐私和通信权益保护</p>
<p>1.甲方的通信自由和通信秘密不受侵犯，乙方对甲方的客户资料和通信信息负有保密义务。但根据法律、行政法规规定，司法、行政机关依法要求乙方提供协助和配合，乙方应给予协助和配合的，不构成违反保密义务。</p>
<p>2.甲方个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别甲方身份或者反映甲方活动情况的各种信息。乙方收集、使用甲方个人信息，应当遵循合法、正当、必要的原则。</p>
<p>3.甲方理解并同意，乙方及其关联公司可以通过业务受理系统登记、纸质返档，通过网络接收、读取并记录等方式，以提供电信服务为目的，在业务活动中收集、使用甲方提供的和甲方使用服务过程中形成的个人信息。乙方有权依法对包含甲方在内的整体用户数据进行分析并加以利用。未经甲方同意，乙方不向除乙方关联公司外的第三方提供甲方个人信息。</p>
<p>4.乙方应严格按照《网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）、《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等法律法规的相关要求，对其在提供服务过程中收集、使用的甲方个人信息履行保护义务。由于技术的限制以及可能存在的各种恶意手段，在不幸发生个人信息安全事件后，乙方将按照法律法规的要求，及时向甲方告知相关情况；同时，乙方还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
<p>5.甲方不得利用乙方提供的服务从事违法犯罪活动或违背公序良俗的活动，不得发送违法信息或未经接收客户同意发送骚扰信息，不得有拨打骚扰电话等不当行为，否则，乙方可以暂停向甲方提供服务，直至终止服务。</p>
<p>6.乙方可能将在提供服务的过程中所收集的甲方信息用作下列用途：（1）向甲方提供服务，或将乙方的最新产品、服务及活动预告及时通知甲方；（2）在乙方提供服务时，用于身份验证、客户服务、安全防范（包括防范打击通讯信息诈骗）、存档和备份用途，确保乙方向甲方提供的产品和服务的安全性；（3）用于乙方审计、数据分析、网络分析和技术研究等内部目的，帮助乙方设计新服务，优化乙方的网络，改善乙方现有服务；（4）使乙方更加了解甲方如何接入和使用乙方的服务，从而针对性地回应甲方的个性化需求，或对甲方和其他用户做出其他方面的回应；（5）提供与甲方更加相关的产品推荐；（6）评估乙方服务中的广告和其他促销及推广活动的效果，并加以改善；（7）软件认证或管理软件升级；（8）让甲方参与有关乙方产品和服务的调查。</p>
<p>乙方通过技术手段对甲方的个人信息进行去标识化处理，去标识化处理后的信息将无法识别信息主体，乙方有权将去标识化的信息用于大数据的开发与利用。</p>
<p>7.除法律法规规定外，甲方有权随时访问和更正个人信息，具体包括： </p>
<p>（1）甲方可以前往乙方营业厅查询、修改个人信息，也可凭借甲方的账号和密码登录乙方网站相关系统完成查询和修改。</p>
<p>（2）甲方可以在乙方营业厅中申请注销号码。甲方注销账户后，乙方将停止提供产品与/或服务，除法律法规另有规定外，乙方将按期删除甲方的个人信息。</p>
<p>七、特别提示</p>
<p>1.甲方应使用取得国家入网许可并具有进网许可标志的终端设备，该终端设备应具有支持其所选服务的相应功能。若甲方使用的终端设备不具有支持其所选服务的相应功能，导致甲方不能享受相关的服务，乙方无需为此承担任何责任。</p>
<p>2.本协议项下号码可能是乙方回收后重新启用的号码，原使用该号码的客户将该号码留作银行及其它服务行业的联系电话且在注销前未予变更时，甲方可能会收到发给前一个客户的通知信息；原使用该号码的客户将该号码用作第三方业务的认证捆绑电话且在注销前未解除绑定关系时，甲方可能因第三方业务提供方的限制而无法使用该号码进行对应第三方业务的认证捆绑。</p>
<p>3.甲方或其受托人已详细阅读本协议的全部条款，甲方或其受托人在签署本协议后即视为完全理解并同意接受本协议的全部条款。</p>
<p>八、争议解决</p>
<p>本协议项下发生的争议，甲乙双方应协商解决，协商不成的，双方可向电信管理部门申诉、向消费者协会等有关部门投诉，或通过下列第_2_种方式解决：</p>
<p>（1）将争议提交      仲裁委员会。该会依据其现行有效的仲裁规则在     进行仲裁。</p>
<p>（2）向 乙方所在地有管辖权的 人民法院提起诉讼。</p>
<p>九.其他</p>
<p>1.甲方办理各类业务所签署的业务受理单、表单、协议等为本协议的补充协议，与本协议冲突部分以补充协议为准，补充协议中未约定部分以本协议为准。</p>
<p>2.乙方关联公司是指乙方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。</p>
<p>3.乙方有权在必要时变更本协议条款。乙方变更本协议条款的，将以包括但不限于在营业网点告示、门户网站公告、电子邮箱、手机短信通知等方式中的一种或多种，向甲方发送本协议的变更情况，甲方可以根据上述方式查阅相关的变更协议条款。本协议条款变更且乙方及时通过上述方式通知甲方后，如果甲方继续使用乙方提供的电信服务，即视为甲方已接受变更后的协议。如果甲方不接受变更后的协议，可向乙方申请销户或携号转网。</p>
<p>4.因不可抗拒力（包括但不限于如地震、山洪、火灾、雷电及其他自然灾害、电磁干扰、战争暴乱、政府行为等）而使本协议部分或全部不能履行，双方互不承担违约责任。</p>
<p>5．本协议一式两份，自乙方盖章、甲方在业务受理单上盖章或签字后生效，有效期为1年，双方各执一份，具有同等法律效力。在有效期满前10天，如任何一方未向对方提出终止或变更协议的，本协议自动展期1年。上述展期不受次数限制。但在甲方携带其他运营商号码使用乙方电信服务的情况下，本协议自乙方盖章、甲方在业务受理单上盖章或签字后，且自乙方提供的移动电话卡激活启用之日（即完成网络切换之日）起生效。对本协议未尽事宜，双方另行协商解决。 </p></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "unicomDeal7",
  data() {
    return {
    type:1,
    };
  },
   watch: {
    "$route.query"() {
      this.type = this.$route.query.type;
    },
  },
  mounted() {
    this.type = this.$route.query.type;
  console.log("type ===========>",this.type);
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.page-home {
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;

  .text {
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    white-space: pre-wrap;
    .title {
      font-weight: 800;
      text-align: center;
      margin: 1rem auto;
    }
    .imgDeal{
      width: 100%;
    }
    h3{
      text-align: center;
    }
  }
}
</style>
